import React from 'react';
import QuestionnairePreviewItem from './QuestionnairePreviewItem';
import { QuestionnaireItem } from './QuestionnairePreview';

interface Props {
	children?: QuestionnaireItem[];
}

const QuestionnairePreviewItems: React.FC<Props> = ({ children }) => {
	return (
		<>
			{children?.map(item => (
				<React.Fragment key={item.id}>
					<QuestionnairePreviewItem item={item} />
				</React.Fragment>
			))}
		</>
	);
};

export default QuestionnairePreviewItems;
